'use client';

import { Provider } from 'react-redux';
import { LoggedInValidator } from './userSlice/loginHandlers';
import customConfigureStore from './store';
import { customerState } from './customerSlice/customerSlice';
import { InitialCustomerSetter } from './customerSlice/customerHandlers';

export function Providers({
  children,
  userInfo,
  customerInfo,
}: {
  children: React.ReactNode;
  userInfo: any;
  customerInfo: customerState;
}) {
  const store = customConfigureStore(userInfo, customerInfo);
  return (
    <Provider store={store}>
      {!!userInfo.userId && (
        <>
          <LoggedInValidator />
        </>
      )}
      {/* TODO: load this component conditionally */}
      <InitialCustomerSetter />
      {children}
    </Provider>
  );
}
